import topmentor from "../images/topmentor.webp";
import javascript from "../images/javascript.jpg";
import react from "../images/react.jpg";
import node from "../images/node.jpg";
import css from "../images/css.jpg";
// Sample data for certification cards
const certifications = [
  {
    title: "Modern Javascript",
    image: javascript, // Replace with actual image URL
    view: "https://drive.google.com/file/d/1lJlT2o-7z0hWppkuMMFHba3PFZkgRxSx/view?usp=sharing",
  },
  {
    title: "The Ultimate React Course",
    view: "Description of Certification 2",
    image: react, // Replace with actual image URL
  },
  {
    title: "NodeJS - The Complete Guide",
    view: "Description of Certification 3",
    image: node, // Replace with actual image URL
  },
  {
    title: "Masters in Data Science by TopMentor",
    view: "https://drive.google.com/file/d/1BOarLD4uoPDJBk5RWMkhaTKX_WcsL00R/view?usp=sharing",
    image: topmentor, // Replace with actual image URL
  },
  {
    title: "CSS - The Complete Guide",
    view: "https://drive.google.com/file/d/1-hf8EzYub2xHcJV9ev3yyFZhP70gR4cS/view?usp=drive_link",
    image: css, // Replace with actual image URL
  },
  {
    title: "SQL Certification",
    view: "https://drive.google.com/file/d/1BF5yQymuubWZqjA489tgJgZkgbx_guFq/view?usp=drive_link",
    image: topmentor, // Replace with actual image URL
  },
];

export default certifications;
